import { render, staticRenderFns } from "./adddialig.vue?vue&type=template&id=1218321a&scoped=true"
import script from "./adddialig.vue?vue&type=script&lang=js"
export * from "./adddialig.vue?vue&type=script&lang=js"
import style0 from "./adddialig.vue?vue&type=style&index=0&id=1218321a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218321a",
  null
  
)

export default component.exports